import {Injectable} from "@angular/core";
import {EventDetail} from "@biletix/core/models/event/event-detail.model";
import {BtxPerformanceListItem} from "@biletix/core/models/event/performance-list-item.model";

@Injectable()
export class EventPageStateService {

  private _currentEventDetail: EventDetail | any;
private _currentPerformanceList: BtxPerformanceListItem[] | any [] = [];
  private _currentEventEnded: boolean = false;

  getCurrentEventDetail(): EventDetail {
    return this._currentEventDetail;
  }

  setCurrentEventDetail(eventDetail: EventDetail) {
    this._currentEventDetail = eventDetail;
  }

  getCurrentPerformanceList(): BtxPerformanceListItem [] {
    return this._currentPerformanceList;
  }
  
  setCurrentPerformanceList(performanceList: BtxPerformanceListItem []) {
    this._currentPerformanceList = performanceList;
    // this._currentPerformanceList.forEach(el => { el.active = (el.status == 's01_onsale')});
  }

  /**
   * Etkinliğin süresi geçmiş mi (tüm performansları bitmiş ve tolerans süresi
   * dolmuş). EventDetailResolver tarafından her çözümlemede set edilir; bu
   * servis lazy EventModule'e provide edildiği için örnek sayfalar arasında
   * yaşamaya devam eder ve bayrağın taşınmaması gerekir.
   */
  isCurrentEventEnded(): boolean {
    return this._currentEventEnded;
  }

  setCurrentEventEnded(eventEnded: boolean) {
    this._currentEventEnded = eventEnded;
  }

}
